var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h1',[_vm._v(_vm._s(_vm.translate("update.title")))]),_c('h2',[_vm._v(_vm._s(_vm.translate("update.subTitle")))])]},proxy:true},{key:"content",fn:function(){return [_c('upload-config')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }